export default __webpack_public_path__ + "static/media/forestly-expl-nn-02_DE.b9f57907.png";